import { useLanguage } from '../hooks/useLanguage';
import { useEffect, useRef } from 'react';

export default function HowItWorks() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('active');
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const steps = t('howItWorks.steps');

  return (
    <section id="how-it-works" ref={sectionRef} className="section-padding bg-white relative overflow-hidden">
      <div className="w-full">
        {/* Header */}
        <div className="text-center mb-20 reveal">
          <span className="inline-block px-4 py-1.5 rounded-full bg-navy-100 border border-navy-200 text-navy-600 text-sm font-semibold tracking-wider mb-6">
            {t('howItWorks.badge')}
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-navy-800">
            {t('howItWorks.title')}{' '}
            <span className="text-brand-500">{t('howItWorks.titleHighlight')}</span>
          </h2>
          <p className="mt-6 text-xl text-navy-400 max-w-3xl mx-auto">
            {t('howItWorks.subtitle')}
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-16 left-[12%] right-[12%] h-0.5 bg-navy-100"></div>
          
          {Array.isArray(steps) && steps.map((step, index) => (
            <div key={index} className="reveal relative text-center" style={{ transitionDelay: `${index * 150}ms` }}>
              {/* Number */}
              <div className="relative inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-navy-700 shadow-lg shadow-navy-700/20 mb-8">
                <span className="text-xl font-black text-white">{step.number}</span>
              </div>
              
              <h3 className="text-xl font-bold text-navy-800 mb-3">{step.title}</h3>
              <p className="text-navy-400">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
